import React, { useState } from "react";
import { AuthProvider, useAuth } from "./providers/AuthContext";
import Dashboard from "./components/Dashboard";
import DraftBoard from "./components/DraftBoard";
import TransactionLog from "./components/TransactionLog";
import AdminPanel from "./components/AdminPanel";
import Login from "./components/Login";
import ChangePasswordModal from "./components/ChangePasswordModal";

type Tab = "dashboard" | "draft" | "transactions" | "admin";

const AppContent: React.FC = () => {
  const { user, isAuthenticated, isCommissioner, mustChangePassword, logout } = useAuth();
  const [activeTab, setActiveTab] = useState<Tab>("dashboard");
  const [year, setYear] = useState(2026);
  const [showChangePassword, setShowChangePassword] = useState(false);

  if (!isAuthenticated) {
    return (
      <div className="app">
        <header className="header">
          <h1>Juiced</h1>
        </header>
        <main style={{ display: "flex", justifyContent: "center", paddingTop: "2rem" }}>
          <Login onSuccess={() => {}} />
        </main>
      </div>
    );
  }

  return (
    <div className="app">
      <header className="header">
        <h1>Juiced</h1>
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <label>
            Year:{" "}
            <select
              value={year}
              onChange={(e) => setYear(Number(e.target.value))}
              className="form-select"
              style={{ width: "auto", display: "inline-block" }}
            >
              <option value={2025}>2025</option>
              <option value={2026}>2026</option>
            </select>
          </label>

          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <span style={{ color: "var(--color-text-secondary)" }}>
              {user?.username}
              {isCommissioner && (
                <span
                  style={{
                    marginLeft: "0.25rem",
                    fontSize: "0.75rem",
                    color: "var(--color-accent)",
                  }}
                >
                  (Commissioner)
                </span>
              )}
            </span>
            <button
              className="btn btn-secondary"
              onClick={() => setShowChangePassword(true)}
              style={{ fontSize: "0.75rem", padding: "0.25rem 0.5rem" }}
            >
              Change Password
            </button>
            <button className="btn btn-secondary" onClick={logout}>
              Logout
            </button>
          </div>
        </div>
      </header>

      <nav className="tabs">
        <button
          className={`tab ${activeTab === "dashboard" ? "active" : ""}`}
          onClick={() => setActiveTab("dashboard")}
        >
          Dashboard
        </button>
        <button
          className={`tab ${activeTab === "draft" ? "active" : ""}`}
          onClick={() => setActiveTab("draft")}
        >
          Draft Board
        </button>
        <button
          className={`tab ${activeTab === "transactions" ? "active" : ""}`}
          onClick={() => setActiveTab("transactions")}
        >
          Transactions
        </button>
        {isCommissioner && (
          <button
            className={`tab ${activeTab === "admin" ? "active" : ""}`}
            onClick={() => setActiveTab("admin")}
          >
            Admin
          </button>
        )}
      </nav>

      <main>
        {activeTab === "dashboard" && <Dashboard year={year} />}
        {activeTab === "draft" && <DraftBoard year={year} />}
        {activeTab === "transactions" && <TransactionLog year={year} />}
        {activeTab === "admin" && isCommissioner && <AdminPanel year={year} />}
      </main>

      {mustChangePassword && (
        <ChangePasswordModal isForced={true} />
      )}

      {showChangePassword && !mustChangePassword && (
        <ChangePasswordModal
          isForced={false}
          onClose={() => setShowChangePassword(false)}
        />
      )}
    </div>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export default App;
